<app-form-page [config]="config" [dialogRef]="dialogRef"></app-form-page>
@if(config.mode === 'list') {
<p style="margin-top: -30px; margin-left: 20px; font-weight: bold">
    Total Invoices Shown: {{ itemTotal | currency}} - Outstanding {{itemOutstanding | currency}}</p>
}
